// extracted by mini-css-extract-plugin
module.exports = {"root":"sd-quiz_root__C77i_","optionCard":"sd-quiz_optionCard__h2_AI","option":"sd-quiz_option__TGhCr"};